export default "__VITE_ASSET__dtKlrBn2__"